import { authGuard } from "@auth0/auth0-vue"
import { setupLayouts } from "virtual:generated-layouts"
import { createRouter, createWebHistory } from "vue-router"
import { routes } from "vue-router/auto-routes"
import { useSettingsStore } from "@/stores"
import useAnalytics from "@/utils/analytics"
import { useIsMobile } from "@/utils/mobile"

const { trackEvent } = useAnalytics()

const { isMobile } = useIsMobile()

// Router
const router = createRouter({
  history: createWebHistory(),
  routes: setupLayouts([...routes]),
})

router.beforeEach((to, _from, next) => {
  // Redirect to the same path without the trailing slash
  if (to.path !== "/" && to.path.endsWith("/")) {
    next(to.path.slice(0, -1))
  } else {
    next()
  }
})

// Auth guard for login
router.beforeEach(async (to) => {
  if (to.name !== "/login") {
    const guard = await authGuard(to)
    if (!guard) {
      return {
        name: "/login",
      }
    }
  }
})

// Mobile navigation is to close menu on every click/touch
router.afterEach(() => {
  // needs store
  const settingsStore = useSettingsStore()

  if (isMobile.value) {
    settingsStore.navOpened = false
  }
})

router.beforeEach((to, from) => {
  // Track page view only if the user is not on the project root
  // TODO: Check this works with dashboard
  if (from.name !== "/" && from.path !== to.path && "page" in from.params) {
    trackEvent("$pageleave")
  }
})

router.afterEach((to) => {
  // Track page view only if the user is not on the project root
  // TODO: Check this works with dashboard
  if (to.name !== "/" && "page" in to.params) {
    trackEvent("$pageview")
  }
})

window.addEventListener("beforeunload", () => {
  trackEvent("$pageleave")
})
export default router
